import React from 'react';
import { Text, Title } from '@mantine/core';
import { SanityRichText } from '@dealstack/frontend/app/pages/HelpBlog/SanityRichText/SanityRichText.tsx';
import { generatePath, Link, useNavigate } from 'react-router-dom';
import { DATE_FORMATS, formatStringDateToUI } from '@dealstack/shared/lib/format/dates/date';
import { ArticlePreviewContainer } from '@dealstack/frontend/app/pages/HelpBlog/ArticlePreview/ArticlePreview.styles.tsx';
import { PortableValue } from '@dealstack/shared/lib/frontend/common-ui/blog-types.ts';
import { StandaloneBadge } from '@dealstack/frontend/shared/components/StandaloneBadge/StandaloneBadge.tsx';
import { ImageUrlBuilder, SanityImageSource } from '@sanity/image-url';
import { HELP_BLOG_ROUTES } from '@dealstack/frontend/shared/shared-routes.ts';

interface Props {
	title: string;
	slug: string;
	richText: PortableValue;
	author: string;
	authorSlug: string;
	publishedAt: string;
	categoryName: string;
	categoryUrl: string;
	mediaResolver: (source: SanityImageSource) => ImageUrlBuilder;
}

export const ArticlePreview = ({
	title,
	slug,
	richText,
	author,
	authorSlug,
	publishedAt,
	categoryName,
	categoryUrl,
	mediaResolver,
}: Props) => {
	const navigate = useNavigate();
	const formattedDate = formatStringDateToUI(publishedAt, DATE_FORMATS.CALENDAR_DATE);

	return (
		<ArticlePreviewContainer onClick={() => navigate(slug)}>
			<div className="category" onClick={(e) => e.stopPropagation()}>
				<StandaloneBadge
					badge={{
						id: categoryUrl,
						label: categoryName,
						onBadgeClick: () => navigate(categoryUrl),
					}}
				/>
			</div>
			<Title size="h4" className="title" fw={600}>
				{title}
			</Title>
			<Link
				to={generatePath(HELP_BLOG_ROUTES.AUTHOR, {
					slug: authorSlug,
				})}
				onClick={(e) => e.stopPropagation()}
			>
				<Text size="sm" className="meta">
					<span className="author">By {author}</span>

					{' • '}

					<span className="published-at">{formattedDate}</span>
				</Text>
			</Link>
			<div className="rich-text">
				<Link to={slug}>
					<SanityRichText
						value={richText}
						mediaResolver={mediaResolver}
						fontSize="0.875rem"
						hideMedia={true}
					/>
				</Link>
			</div>
		</ArticlePreviewContainer>
	);
};
